var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGraphTypeBarGray(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3D4C59",
    fillRule: "evenodd",
    d: "M3,12 C4.1045695,12 5,12.8954305 5,14 L5,19 C5,19.5522847 4.55228475,20 4,20 L2,20 C1.44771525,20 1,19.5522847 1,19 L1,14 C1,12.8954305 1.8954305,12 3,12 Z M9,4 C10.1045695,4 11,4.8954305 11,6 L11,19 C11,19.5522847 10.5522847,20 10,20 L8,20 C7.44771525,20 7,19.5522847 7,19 L7,6 C7,4.8954305 7.8954305,4 9,4 Z M15,9 C16.1045695,9 17,9.8954305 17,11 L17,19 C17,19.5522847 16.5522847,20 16,20 L14,20 C13.4477153,20 13,19.5522847 13,19 L13,11 C13,9.8954305 13.8954305,9 15,9 Z M21,11 C22.1045695,11 23,11.8954305 23,13 L23,19 C23,19.5522847 22.5522847,20 22,20 L20,20 C19.4477153,20 19,19.5522847 19,19 L19,13 C19,11.8954305 19.8954305,11 21,11 Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphTypeBarGray);
export default __webpack_public_path__ + "static/media/graph_type_bar_gray.9f9e05bd.svg";
export { ForwardRef as ReactComponent };